


































import Vue from 'vue'
import {
  DictServiceProxy,
  AppMenuServiceProxy,
  AppMenuInputDTO,
  MenuServiceProxy
} from '@/service-proxies/app-v2/system.service-proxies'
const aMenuService = new AppMenuServiceProxy()
const dsp = new DictServiceProxy()
const menuService = new MenuServiceProxy()

export default Vue.extend({
  data() {
    return {
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      data: [],
      spinning: false,
      halfCheckedKeys: [],
      kindList: [],
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '菜单名称',
          dataIndex: 'title',
          width: 200,
        },
        {
          title: '菜单属性',
          dataIndex: 'kind',
          width: 120,
          customRender: v => {
            return this.kindList.find(item => Number(item.k) === v)?.v || v
          },
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 120,
        },
      ]
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    appId: {
      type: String,
      default: '',
    },
    checkMenuList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    checkMenuList: {
      handler(val) {
        this.selectedKeys = val
      },
      deep: true,
      immediate: true
    },
  },
  created() {
    this.load()
    // 菜单属性字典
    dsp.dictionary('menu_kind').then(res => {
      this.kindList = res.data.map(item => {
        return {
          k: item.dictKey,
          v: item.dictValue,
        }
      })
    })
  },
  methods: {
    async load() {
      this.spinning = true
      this.data = []
      let res = await menuService.lazyList(undefined, '3', undefined, undefined)
      let temp = res.data
      if (!temp) return
      this.data = this.handleTableData(temp)
      this.checkedKeys = this.checkMenuList
      this.selectedKeys = this.checkMenuList
      this.spinning = false
    },
    handleTableData(data) {
      if (!data || !data.length) {
        return
      }
      data.slice(0).reverse().map((item, i, arr) => {
        item.title = item.name
        item.key = item.id
        if (item.category === 2) { // 删除类型为‘按钮’的菜单项 (category:1 菜单，2 按钮)
          data.splice(arr.length - i - 1, 1)
        }

        if (item.hasOwnProperty('children')) {
          // 当某菜单下的所有菜单类型均为‘按钮’时，删除children
          let filters = item.children.filter(child => child.category !== 2)
          if (filters.length) {
            this.handleTableData(item.children)
          } else {
            delete item.children
          }
        }
      })
      return data
    },
    onExpand(expandedKeys: any) {
      console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys
      // this.autoExpandParent = true
    },
    onCheck(checkedKeys: any, e) {
      this.halfCheckedKeys = e && e.halfCheckedKeys
      this.checkedKeys = checkedKeys
    },
    onApply() {
      aMenuService
        .bindMenuId(
          new AppMenuInputDTO({
            menuIds: [...this.selectedKeys],
            appId: this.appId,
          }),
        )
        .then(() => {
          this.$emit('addMenuBack', true)
        })
    },
    cancel() {
      this.$emit('addMenuBack')
    },
    onSelect(keys, rows) {
      console.log(keys, rows)
      this.selectedKeys = keys
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.parentId !== '0' && record.kind === 1, // 静态菜单仅第一层级可以勾选，动态菜单都可以勾选
        }
      }
    }
  },
})
